export const LOCALE = navigator.language; // TODO: change this locale when language switching is implemented on the portal.
export const DECIMAL_SEPARATOR = new Intl.NumberFormat(LOCALE).formatToParts(1000.1).find(part => part.type === "decimal")["value"];

export function parseFloat(value, defaultValue = null){
  value = Number.parseFloat(value);
  return isNaN(value) ? defaultValue : value;
}

export function toUnit(value, unit, decimalPlaces = 2, defaultValue='/') {
  if(value == null) {
    return defaultValue;
  }
  const val = parseFloat(value).toFixed(decimalPlaces)
  const formattedValue = DECIMAL_SEPARATOR === "," ? val.toString().replace(".", ",") : val
  return formattedValue + " " + unit;
}

export function roundToDecimalPlaces(value, decimalPlaces = 2) {
  return +value.toFixed(decimalPlaces)
}

export function parseLocalFloat(value, decimalPlaces = 2) {
  const val = parseFloat(value).toFixed(decimalPlaces)
  return DECIMAL_SEPARATOR === "," ? val.toString().replace(".", ",") : val
}

// Input component formats
export const POSITIVE_NUMBER = { decimalPlaces: 0, negative: false }
export const DECIMAL_NUMBER_2 = { decimalPlaces: 2, negative: false }
export const DECIMAL_NUMBER_5 = { decimalPlaces: 5, negative: false }
